import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default function NavLink({ path, primaryColor, handlePathDirection }) {
    const toPath = handlePathDirection(path);

    return (
        <Link to={toPath} style={{ textDecoration: 'none' }}>
            <Button sx={{ display: 'block', fontWeight: 'bold', pr: 0.5 }} color={primaryColor ? "primary" : "white"} variant="text">
                {path}
            </Button>
        </Link>
    );
}